module.exports = __webpack_public_path__ + "static/media/11-10.38fcc643.mp3";